import request from '@/utils/request'


export function schoolSta(query) {
  return request({
    url: '/biz/admin/statistics/school/page',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}

export function schoolGoodsSta(query) {
  return request({
    url: '/biz/admin/statistics/school/goods/list',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}

export function schoolGoodsStudentPage(query) {
  return request({
    url: '/biz/admin/statistics/school/goods/sku/student/page',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}

export function schoolGoodsStudentStatistics(query) {
  return request({
    url: '/biz/admin/statistics/school/goods/sku/student/statistics',
    method: 'post',
    headers: {"repeatSubmit": false},
    data: query
  })
}


